module.exports = __webpack_public_path__ + "images/signup-users.png";